import React from "react";

const TermsAndConditions = ({ terms }) => {
  if (!terms) return null;

  return (
    <div
      className="text-[16px] text-[#B0B0B0] leading-6"
      dangerouslySetInnerHTML={{ __html: terms }}
    />
  );
};

export default TermsAndConditions;
